module.exports = __webpack_public_path__ + "static/media/0day@2x.e02dce34.png";